import React, { useState } from "react";

import { useInlet } from "context/inletContext";

import Scanner from "./layout";

function ScannerContainer() {
  const { setGroupId, getReservation, getReservationByCC, events } = useInlet();
  const [showCC, setShowCC] = useState(false);

  const handleScan = (data) => {
    setGroupId(data);
    handleHideCC();
    getReservation(data);
  };
  const handleShowCC = () => {
    setShowCC(true);
  };
  const handleHideCC = () => {
    setShowCC(false);
  };
  const handleGetReservationByCC = (values) => {
    handleHideCC();
    getReservationByCC(values);
  };
  return (
    <Scanner
      showCC={showCC}
      onHandleScan={handleScan}
      onHandleShowCC={handleShowCC}
      onHandleHideCC={handleHideCC}
      onGetReservationByCC={handleGetReservationByCC}
      events={events}
    />
  );
}

export default ScannerContainer;
